import { render, staticRenderFns } from "./IngredientImageComposition.vue?vue&type=template&id=de1b10be&scoped=true&"
import script from "./IngredientImageComposition.vue?vue&type=script&lang=js&"
export * from "./IngredientImageComposition.vue?vue&type=script&lang=js&"
import style0 from "./IngredientImageComposition.vue?vue&type=style&index=0&id=de1b10be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1b10be",
  null
  
)

export default component.exports